import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Grid, Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { getCar } from 'redux/actions/UserCar';
import { postAddVehicle } from 'redux/actions/UserVehicle';
import MoreDetails from 'components/moreDetails/MoreDetails';
import CommonTable from 'components/commonTable/CommonTable';
import CommonMultiImageForm from 'components/commonMultiImageForm/CommonMultiImageForm';
import Loader from 'components/loader/Loader';
import VehicleInfo from './VehicleInfo';
import { vehicleDialogData } from '../VendorBreadCrumbData';
import MatrixDriverVendor from './MatrixDriverVendor';
import { matrixDriverData } from './MatrixDriverData';

function TabDriverVendor(props) {
  const dispatch = useDispatch();
  const { state } = useLocation();
  const { id, status } = state;
  const [selectedImage, setSelectedImage] = useState(null);
  const [showOtherComponent, setShowOtherComponent] = useState(false);
  const [open, setOpen] = useState(false);
  const handleChange = (event, newValue) => {
    props?.handleChange(newValue);
  };

  useEffect(() => {
    dispatch(getCar());
  }, []);

  const postAddVehicleSuccess = useSelector(
    (state) => state?.userAddVehicle?.userAddVehicle?.success
  );
  const carList = useSelector((state) => state?.userCar?.userCar?.data);
  const carOption = carList?.body?.map((val, idx) => {
    return { value: val?.id, label: val?.carType, seater: val?.seater };
  });

  const onImageChange = (val) => {
    setSelectedImage(val);
  };

  const onSubmit = (val, code) => {
    const data = {
      ...val,
      carType: 'DOC',
      seating: parseInt(val?.seating),
      id: id,
      driverId: id,
      type: 'driver',
      avtar: selectedImage,
    };
    let formData = new FormData();
    Object.keys(data).map((val) => {
      formData.append(val, data[val]);
    });
    dispatch(postAddVehicle(formData));
  };

  useEffect(() => {
    if (postAddVehicleSuccess) {
      setShowOtherComponent(true);
    } else {
      setShowOtherComponent(false);
    }
  }, [postAddVehicleSuccess]);

  const addVehicle = () => {
    setOpen(true);
    setShowOtherComponent(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onDialog = (data, code) => {
    onSubmit(data, code);
    setOpen(true);
  };

  return (
    <Grid container>
      <Grid item className="tabContainer" xs={12}>
        <Box className="contentBoxStyle">
          <TabContext value={props?.value}>
            <Grid container className="tabBoxStyle justifyBetween flexRow">
              <Grid item xs={8}>
                <TabList
                  className="minHeight32"
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                  TabIndicatorProps={{
                    style: { backgroundColor: 'white' },
                  }}
                >
                  <Tab label="Matrix" value="matrix" className="tabStyle" />
                  <Tab label="Ticket" value="ticket" className="tabStyle" />
                  <Tab
                    label="More Details"
                    value="moreDetails"
                    className="tabStyle"
                  />
                  {props?.driverVehicleId && (
                    <Tab
                      label="Vehicle Info"
                      value="Vehicle"
                      className="tabStyle"
                    />
                  )}
                </TabList>
              </Grid>
              {props?.driverVehicleId
                ? ''
                : status === 'Active' && (
                    <Grid
                      item
                      container
                      xs={4}
                      direction="row"
                      justifyContent="flex-end"
                    >
                      <Button
                        className="btnSubvendorAdd"
                        onClick={() => addVehicle()}
                      >
                        Vehicle +
                      </Button>
                    </Grid>
                  )}
            </Grid>
            <TabPanel
              value="matrix"
              className="vendotTable tabPanelStyle"
            >
              {props?.loaderDriverMatrix ? (
                <Loader />
              ) : (
                <MatrixDriverVendor
                  matrix={matrixDriverData(
                    props.details,
                    props?.tabDetails?.matrixData
                  )}
                />
              )}
            </TabPanel>
            <TabPanel value="ticket" className="vendotTable tabPanelStyle">
              {props?.loaderDriverTicket ? (
                <Loader />
              ) : (
                <CommonTable
                  data={props?.tabDetails?.ticketData}
                  handleChangePage={props?.handleChangePage}
                  handleChangeRowsPerPage={props?.handleChangeRowsPerPage}
                  page={props?.page}
                  isClickable={false}
                  rowsPerPage={props?.rowsPerPage}
                />
              )}
            </TabPanel>
            <TabPanel value="moreDetails" className="vendotTable tabPanelStyle">
              {props?.loaderDriverMoreDetails ? (
                <Loader />
              ) : (
                <MoreDetails details={props?.tabDetails?.moreDetailsData} driverId={props.driverId} refreshCompliance={props.refreshCompliance} />
              )}
            </TabPanel>
            <TabPanel value="Vehicle" className="vendotTable tabPanelStyle">
              {props?.loaderDriverVehicleData ? (
                <Loader />
              ) : (
                <VehicleInfo
                  vehicleInfo={props?.vehicleInfo}
                  vehicleImage={props?.vehicleMoreData}
                  amenitiesVehicle={props?.amenitiesVehicle}
                  vehicleMoreData={props?.vehicleMoreData}
                  vehicleMatrixData={props?.vehicleMatrixData}
                  addVehicle={addVehicle}
                  carOption={carOption}
                  driverVehicleId={props?.driverVehicleId}
                  complianceShow={'true'}
                  editButton={props?.editButton}
                />
              )}
            </TabPanel>
          </TabContext>
        </Box>
      </Grid>
      {open && (
        <CommonMultiImageForm
          open={open}
          handleClose={handleClose}
          formData={vehicleDialogData(carOption)}
          button={'dialogButton'}
          onSubmittBtn={onDialog}
          setOpen={false}
          selectType={'Create'}
          type={'Vehicle' + ' '}
          onImageChange={onImageChange}
          tabName={'vehicle'}
          showOtherComponent={showOtherComponent}
        />
      )}
    </Grid>
  );
}

export default TabDriverVendor;
